import { MessageCardPayload } from "../contracts/MessageCardPayload";
import { MessageResponse } from "../contracts/MessageResponse";
import { SessionSystemLineResponse } from "../contracts/SessionSystemLineResponse";
import { Message } from "../models/Message";
import { PaymentReminderCard } from "../models/PaymentReminderCard";
import { SessionSystemLine } from "../models/SessionSystemLine";
import { toMessageAttachment } from "./AttachmentResponseMapper";
import { toOccurrenceSlot } from "./OccurrenceSlotMapper";

/** Maps message responses from the API to frontend models. */
export class MessageResponseMapper {
  toMessage = (response: MessageResponse): Message => ({
    id: response.id,
    threadId: response.threadId,
    authorKind: response.authorKind,
    authorId: response.authorId ?? null,
    authorName: response.authorName ?? null,
    body: response.body,
    kind: response.kind,
    payload: response.payload ?? null,
    systemLine: response.kind === "System" ? this.toSystemLine(response.payload) : null,
    card: response.kind === "Card" ? this.toCard(response.payload) : null,
    createdAt: new Date(response.createdAt),
    isMine: response.isMine,
    deletedAt: response.deletedAt ? new Date(response.deletedAt) : null,
    attachments: (response.attachments ?? []).map(toMessageAttachment),
    canDelete: response.canDelete ?? false,
    reportedByMe: response.reportedByMe ?? false,
  });

  private toSystemLine = (payload: Record<string, unknown> | null): SessionSystemLine | null => {
    if (!payload) return null;
    const line = payload as unknown as SessionSystemLineResponse;
    return {
      type: line.type,
      from: toOccurrenceSlot(line.from ?? null),
      to: toOccurrenceSlot(line.to ?? null),
      memberName: line.memberName ?? null,
    };
  };

  private toCard = (payload: Record<string, unknown> | null): PaymentReminderCard | null => {
    if (!payload) return null;
    const card = payload as unknown as MessageCardPayload;
    if (card.type !== "PaymentReminder") return null;
    return {
      type: card.type,
      paymentId: card.paymentId,
      amountMinor: card.amountMinor,
      currency: card.currency,
      dueDate: card.dueDate ?? null,
      periodLabel: card.periodLabel ?? null,
      portalPath: card.portalPath,
    };
  };

  toMessages = (responses: MessageResponse[]): Message[] => responses.map(this.toMessage);
}
